import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconLiveryGuide = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    viewBox="0 0 34 34"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-livery-guide_svg__a)">
      <path
        fill="#fff"
        fillOpacity={0.95}
        d="M23.875 6.25c1.016 0 1.875.86 1.875 1.875v9.61c0 .663-.273 1.288-.742 1.757l-3.555 3.555c-.469.469-1.094.703-1.758.703h-9.57a1.851 1.851 0 0 1-1.875-1.875V8.125c0-1.016.82-1.875 1.875-1.875h13.75ZM10.75 8.75v12.5h8.75v-2.5c0-.664.547-1.25 1.25-1.25h2.46l.04-8.75h-12.5Z"
      />
    </g>
    <defs>
      <filter
        id="icon-livery-guide_svg__a"
        width={36}
        height={36}
        x={-1}
        y={-1}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9632_25049"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_9632_25049"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_9632_25049"
          result="effect2_dropShadow_9632_25049"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_9632_25049"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconLiveryGuide;
